$pink: #f43879;
$background: #240c08;
$light-grey: #c2c1c1;
$code-block: #2b313c;

.devErrorContainer {
  padding: 20px;
  background: $background;
  font-size: 16px;
  color: $pink;
  border: 2px solid $pink;
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
}

.stack {
  background: $code-block;
  color: $light-grey;
  border-radius: 5px;
  padding: 10px;
}

.title {
  font-weight: 700;
  color: $pink;
}

.trace {
  line-height: 150%;
}

.publicError {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  height: 100%;
  color: #656568;
}
